import { decodeMessageContent } from '../internal/conversation/decodeMessageContent';

export type ConversationMessage = { role: string; is_final: boolean; content: unknown };

export type PickFinalReplyOptions = { anyEnvelope?: boolean };

// Reply for the CURRENT grade. The conversation is reused across grades, so scan
// after the last user message and take the latest is_final `result`; the first
// would be a stale prior grade. undefined until this grade finishes.
export function pickFinalReply(
  messages: ConversationMessage[],
  { anyEnvelope = false }: PickFinalReplyOptions = {},
): string | undefined {
  let start = 0;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'user') {
      start = i + 1;
      break;
    }
  }

  let reply: string | undefined;
  for (let i = start; i < messages.length; i++) {
    const message = messages[i];
    if (message.role !== 'assistant' || !message.is_final) {
      continue;
    }
    const payload = decodeMessageContent(message.content);
    if ((anyEnvelope || payload?.type === 'result') && typeof payload?.result === 'string' && payload.result) {
      reply = payload.result; // keep scanning; the current grade's result is the latest one
    }
  }
  return reply;
}
